import apiClient from './api';

export interface DepartmentCreateRequest {
  name: string;
}

export interface DepartmentUpdateRequest {
  name: string;
}

export const adminDepartmentService = {
  /** 학과 추가 */
  createDepartment: async (universityId: number, data: DepartmentCreateRequest): Promise<void> => {
    await apiClient.post(`/admin/universities/${universityId}/departments`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 학과 수정 */
  updateDepartment: async (departmentId: number, data: DepartmentUpdateRequest): Promise<void> => {
    await apiClient.patch(`/admin/departments/${departmentId}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 학과 삭제 */
  deleteDepartment: async (departmentId: number): Promise<void> => {
    await apiClient.delete(`/admin/departments/${departmentId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },
};
